import type { Element, GroupElement } from '@/components/canvas/document/publicTypes';

/**
 * 递归计算元素在**当前 Page 页内**的绝对位置（向上追溯父组链）。
 * 不含 `page.workspaceLayout`；世界坐标见 `marqueeSelectUtils.toWorldElement`。
 */
export function getElementAbsolutePos(id: string, elements: Element[]): { x: number; y: number } {
  const el = elements.find((e) => e.id === id);
  if (!el) return { x: 0, y: 0 };
  const parentGrp = elements.find(
    (e) => e.type === 'group' && ((e as GroupElement).data.children ?? []).includes(id),
  ) as GroupElement | undefined;
  if (!parentGrp) return { x: el.layout.x, y: el.layout.y };
  const parentPos = getElementAbsolutePos(parentGrp.id, elements);
  return { x: parentPos.x + el.layout.x, y: parentPos.y + el.layout.y };
}
